import React from 'react';

import DownloadLink from 'components/DownloadLink'
import FieldList from 'components/FieldList'

import './App.css';

const App = () => (
  <React.Fragment>
    <DownloadLink />
    <FieldList />
  </React.Fragment>
)

export default App;
